import { SortingRule } from "react-table";
import { INotify, INotifyCall } from "./constants";

export const actionTypes = {
  GET_NOTIFICATIONS: "GET_NOTIFICATIONS",
  GET_NOTIFICATIONS_SUCCESS: "GET_NOTIFICATIONS_SUCCESS",
  GET_NOTIFICATIONS_FAILURE: "GET_NOTIFICATIONS_FAILURE",
  DEL_NOTIFY: "DEL_NOTIFY",
  DEL_NOTIFY_SUCCESS: "DEL_NOTIFY_SUCCESS",
  DEL_NOTIFY_FAILURE: "DEL_NOTIFY_FAILURE",
  SEND_NOTIFY: "SEND_NOTIFY",
  SEND_NOTIFY_SUCCESS: "SEND_NOTIFY_SUCCESS",
  SEND_NOTIFY_FAILURE: "SEND_NOTIFY_FAILURE",
  NOTIFY_GET_ALL_ROLES: "NOTIFY_GET_ALL_ROLES",
  NOTIFY_GET_ALL_ROLES_SUCCESS: "NOTIFY_GET_ALL_ROLES_SUCCESS",
  NOTIFY_GET_ALL_ROLES_FAILURE: "NOTIFY_GET_ALL_ROLES_FAILURE",
  UPDATE_NOTIFY: "UPDATE_NOTIFY",
  UPDATE_NOTIFY_SUCCESS: "UPDATE_NOTIFY_SUCCESS",
  UPDATE_NOTIFY_FAILURE: "UPDATE_NOTIFY_FAILURE",
  REPLAY_NOTIFY: "REPLAY_NOTIFY",
  REPLAY_NOTIFY_SUCCESS: "REPLAY_NOTIFY_SUCCESS",
  REPLAY_NOTIFY_FAILURE: "REPLAY_NOTIFY_FAILURE",
};

export const getNotificationsAction = (body: INotifyCall, sortBy: SortingRule<{}>[]) => ({
  type: actionTypes.GET_NOTIFICATIONS,
  payload: {body, sortBy},
});

export const getNotificationsSuccess = (response: any) => ({
  type: actionTypes.GET_NOTIFICATIONS_SUCCESS,
  payload: response,
});

export const getNotificationsFailure = (err: Error) => ({
  type: actionTypes.GET_NOTIFICATIONS_FAILURE,
  err,
});

export const deleteNotifyAction = (id: string) => ({
  type: actionTypes.DEL_NOTIFY,
  payload: id,
});

export const deleteNotifySuccess = (response: any) => ({
  type: actionTypes.DEL_NOTIFY_SUCCESS,
  payload: response,
});

export const deleteNotifyFailure = (err: Error) => ({
  type: actionTypes.DEL_NOTIFY_FAILURE,
  err,
});

export const sendNotifyAction = (data: INotify) => ({
  type: actionTypes.SEND_NOTIFY,
  payload: data,
});

export const sendNotifySuccess = (response: any) => ({
  type: actionTypes.SEND_NOTIFY_SUCCESS,
  payload: response,
});

export const sendNotifyFailure = (err: Error) => ({
  type: actionTypes.SEND_NOTIFY_FAILURE,
  err,
});

export const updateNotifyAction = (data: INotify) => ({
  type: actionTypes.UPDATE_NOTIFY,
  payload: data,
});

export const updateNotifySuccess = (response: any) => ({
  type: actionTypes.UPDATE_NOTIFY_SUCCESS,
  payload: response,
});

export const updateNotifyFailure = (err: Error) => ({
  type: actionTypes.UPDATE_NOTIFY_FAILURE,
  err,
});

export const getAllRolesAction = () => ({
  type: actionTypes.NOTIFY_GET_ALL_ROLES,
});

export const getAllRolesSuccess = (response: any) => ({
  type: actionTypes.NOTIFY_GET_ALL_ROLES_SUCCESS,
  payload: response,
});

export const getAllRolesFailure = (err: Error) => ({
  type: actionTypes.NOTIFY_GET_ALL_ROLES_FAILURE,
  err,
});

export const replayNotifyAction = (data: INotify) => ({
  type: actionTypes.REPLAY_NOTIFY,
  payload: data,
});

export const replayNotifySuccess = (response: any) => ({
  type: actionTypes.REPLAY_NOTIFY_SUCCESS,
  payload: response,
});

export const replayNotifyFailure = (err: Error) => ({
  type: actionTypes.REPLAY_NOTIFY_FAILURE,
  err,
});
